var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9774 14.8846L11.9788 12.2732M11.9788 12.2732C11.9781 11.4542 12.5396 10.8249 13.2315 10.8241C13.9242 10.8241 14.4856 11.4534 14.4856 12.2732L14.487 13.1575M11.9788 12.2732L11.9936 7.76268C11.9936 6.94283 11.4321 6.2782 10.7395 6.2782H10.7382C10.0463 6.27906 9.48606 6.94366 9.48677 7.76262C9.4927 13.56 9.49224 15.821 9.4854 15.8193C8.33671 15.8193 7.46706 14.0918 5.95915 14.0918C4.4512 14.0918 4.19818 15.0409 4.80073 15.8807C5.20244 16.4405 9.4854 22 9.4854 22H15.502C17.7111 22 19.502 20.2092 19.502 18.0001L19.5021 14.1998C19.5021 13.38 18.9406 12.7153 18.248 12.7153H18.2467C17.5548 12.7162 16.9945 13.3808 16.9953 14.1998M14.487 13.1575V14.8846M14.487 13.1575C14.4863 12.3385 15.0466 11.6738 15.7385 11.673H15.7397C16.4324 11.673 16.9939 12.3376 16.9939 13.1575L16.9953 14.1998M16.9953 14.1998L16.9939 14.8846M9.2578 10.7758H5C3.34314 10.7758 2 9.35095 2 7.59333V5.18245C2 3.42483 3.34315 2 5 2H19C20.6569 2 22 3.42483 22 5.18245V7.59333C22 9.35095 20.6569 10.7758 19 10.7758H12.3793",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.81d8abbfdb4f10a884d6183c2a67ac9f.svg";
export { ForwardRef as ReactComponent };